import React from 'react';

interface IconProps {
    className?: string;
}

export const IconTotal: React.FC<IconProps> = ({ className }) => (
    <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M3 5h18v2H3V5zm0 6h18v2H3v-2zm0 6h12v2H3v-2z" />
    </svg>
);

export const IconPending: React.FC<IconProps> = ({ className }) => (
    <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2zm1 5h-2v6l5 3 .999-1.732L13 12.5V7z" />
    </svg>
);

export const IconApproved: React.FC<IconProps> = ({ className }) => (
    <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2zm-1 14-4-4 1.414-1.414L11 12.172l5.586-5.586L18 8l-7 8z" />
    </svg>
);

export const IconDeclined: React.FC<IconProps> = ({ className }) => (
    <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2zm4.95 14.536-1.414 1.414L12 14.414 8.464 17.95 7.05 16.536 10.586 13 7.05 9.464 8.464 8.05 12 11.586 15.536 8.05l1.414 1.414L13.414 13l3.536 3.536z" />
    </svg>
);

export const IconWithinSla: React.FC<IconProps> = ({ className }) => (
    <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 1 3 5v6c0 5.25 3.438 10.125 9 12 5.562-1.875 9-6.75 9-12V5l-9-4zm-1 15-3-3 1.414-1.414L11 12.172l4.586-4.586L17 9l-6 7z" />
    </svg>
);

export const IconOverSla: React.FC<IconProps> = ({ className }) => (
    <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2zm1 5h-2v6h6v-2h-4V7z" />
    </svg>
);
